import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import TextFieldBox from "../components/text_field_box";
import TextAreaBox from "../components/text_area";
import "../poll_and_survey.css";
import { DatePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import { CustomDatePicker } from "../../../../components/custom/datepicker";
import moment from "moment";
import { LANGUAGE_TABS } from "../view/question_lists";
import RadioIcon from "../../../../assets/poll_survey/radio.svg";
import CheckboxIcon from "../../../../assets/poll_survey/checkbox.svg";
import StarIcon from "../../../../assets/poll_survey/star.svg";
import { TextBox } from "@progress/kendo-react-inputs";
import { Reusable_table } from "../../../../components/reusableItems/table";
import { ShowFullScreenDialog } from "../../../../components/reusableItems/fullscreen_dialog";
import { ConfigDataForRecipient } from "../configData";



export const ReviewAndPublish = (props) => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const minMinute = new Date(new Date().getTime() + 15 * 60000);
  const [tab, setTab] = useState(LANGUAGE_TABS.EN);

  const [tempData, setTempData] = useState([]);
  const [recipientDialogTitle, setRecipientDialogTitle] = useState("");

  const [showRecipientDialog, setShowRecipientDialog] = useState(false);


  const onTabChange = (tab) => {
    setTab(tab);
  };


  const RenderRow = ({ title, value }) => {
    return (
      <>
        {value ? (
          <>
            <div className="poll_survey_child_box_main_detail_items">
              <div className="poll_survey_child_box_main_detail_items_title poll_survey_center_item poll_survey_detail_padding_bottom">
                {title}
              </div>
              <div className="poll_survey_child_box_main_detail_items_splitter" />
              <div className="poll_survey_center_item poll_survey_child_box_main_detail_items_subdetail poll_survey_detail_padding_bottom">
                {value}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };



  const Item = ({ question, index }) => {

    return (
      <div className="poll_and_survey_create_item_main_box">
        <div className="flex-between">
          <div className="poll_and_survey_create_item_main_box_title">{`Question ${index + 1}`}</div>
          <div className="required-text" key={index}>{question.is_required ? 'Required' : ''}</div>
        </div>
        <div className="poll_and_survey_create_item_main_box_field" style={{ margin: "1px" }}>
          <div className="poll_and_survey_create_item_main_box_title">{`${question.qtitle}`}</div>
          {question.options.map((option, index) => (
            <div>
              <div className="poll-survey-option-item" style={{ marginBottom: "5px" }}>
                <img src={question.qtype.value === 'single-choice' ? RadioIcon : CheckboxIcon} className="delete-button-icon" />
                <div className="poll_and_survey_create_item_main_box_title_review">{`${option.value}`}</div>
              </div>
              {option.type === 'other' ?
                <div>
                  <TextBox
                    className="review-text-field"
                    value={"Please Input"}
                    disabled
                  />
                </div> : null}
            </div>
          ))}

          {question.qtype.value == "star-rating" ? (
            <div className="poll-survey-option-item" style={{ marginBottom: "5px" }}>
              <img src={StarIcon} className="delete-button-icon" />
              <img src={StarIcon} className="delete-button-icon" />
              <img src={StarIcon} className="delete-button-icon" />
              <img src={StarIcon} className="delete-button-icon" />
            </div>
          ) : null}

          {question.qtype.value == "open-ended" ? (
            <TextAreaBox
              className="review-text-field"
              value={"Please Input"}
              disabled={true}
            />
          ) : null}
        </div>
      </div>
    );
  }

  const MAX_DISPLAY_COUNT = 3;

  const RecipientView = ({ title, collaborators, onViewClick }) => {
    const displayNames = (collaborators || []).slice(0, MAX_DISPLAY_COUNT);

    return (
      <div className="poll_survey_child_box_main_detail_items" key={title}>
        <div className="poll_survey_child_box_main_detail_items_title poll_survey_center_item poll_survey_detail_padding_bottom">
          {title}
        </div>
        <div className="poll_survey_child_box_main_detail_items_splitter" />
        <div className="poll_survey_center_item poll_survey_child_box_main_detail_items_subdetail poll_survey_detail_padding_bottom">
          <span >
            {`${collaborators.length} Recipients `}
          </span>
          <span><span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => onViewClick && onViewClick(title, collaborators)}>{`View`}</span>
          </span>
        </div>
      </div>

    );
  };

  return (
    <>
      {showRecipientDialog && (
        <ShowFullScreenDialog
          cancelbtn={() => {
            setShowRecipientDialog(false);
            setTempData([]);
            setRecipientDialogTitle("");
          }}
          title={recipientDialogTitle}
          children={
            <>
              <div className="poll_and_survey_scroll_box_detail" style={{ maxHeight: '500px' }}>

                <Reusable_table
                  header={ConfigDataForRecipient}
                  data={tempData}
                  pagination={false}
                  calculatePagi={false}
                  pageChangeLoading={false}
                  showRow={true}
                  checkbox={false}
                />
              </div>
            </>
          }
        />
      )}
      <div className="poll_and_survey_scroll_box">



        <div style={{ marginTop: "20px" }}>

          <RenderRow
            title={"Title"}
            value={props.editData.title}
          />

          <RenderRow
            title={"Title in Description"}
            value={props.editData.description}
          />

          <RenderRow
            title={"Start Date"}
            value={moment(props.editData.start_date).format("DD-MM-YYYY")}
          />

          <RenderRow
            title={"Start Time"}
            value={moment(props.editData.start_time).format("hh:mm A")}
          />

          <RenderRow
            title={"End Date"}
            value={moment(props.editData.end_date).format("DD-MM-YYYY")}
          />

          <RenderRow
            title={"End Time"}
            value={moment(props.editData.end_time).format("hh:mm A")}
          />

          <RenderRow
            title={"Allow participants to view the survey after it is closed or concluded"}
            value={props.editData.user_visibility? "True": "False"}
          />

          <RecipientView
            title={"Distribution"}
            collaborators={props.editData.recipient}
            onViewClick={(title, collaborators) => {
              const cleanedData = collaborators.map(item => {
                const empSapTrimmed = String(item.emp_sap_no).replace(/^0+/, "");
                const idStr = String(item.id);
                return {
                  ...item,
                  id: empSapTrimmed === idStr ? "-" : item.id
                };
              });
              
              setTempData(cleanedData);

              setRecipientDialogTitle(title);
              setShowRecipientDialog(true);
            }}
          />

          <RecipientView
            title={"Collaborator"}
            collaborators={props.editData.collaborator}
            onViewClick={(title, collaborators) => {
              const cleanedData = collaborators.map(item => {
                const empSapTrimmed = String(item.emp_sap_no).replace(/^0+/, "");
                const idStr = String(item.id);
                return {
                  ...item,
                  id: empSapTrimmed === idStr ? "-" : item.id
                };
              });
              
              setTempData(cleanedData);

              setRecipientDialogTitle(title);
              setShowRecipientDialog(true);
            }}
          />

        </div>

        <div className="poll_and_survey_tab_content">
          <div className="tabs">
            <div
              onClick={() => onTabChange(LANGUAGE_TABS.EN)}
              className={`tab ${tab === LANGUAGE_TABS.EN ? "isactive" : ""
                }`}
            >
              {LANGUAGE_TABS.EN}
            </div>
            <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
            <div
              onClick={() => onTabChange(LANGUAGE_TABS.CH)}
              className={`tab ${tab === LANGUAGE_TABS.CH ? "isactive" : ""
                }`}
            >
              {LANGUAGE_TABS.CH}
            </div>
          </div>
        </div>


        {tab == LANGUAGE_TABS.EN ? (
          props.enQuestions.map((question, index) => (
            <Item question={question} index={index} key={index} />
          ))

        ) : (
          props.zhQuestions.map((question, index) => (
            <Item question={question} index={index} key={index} />
          ))

        )

        }

      </div>
    </>
  );
};
